import { render, staticRenderFns } from "./AuthPage.vue?vue&type=template&id=cd38c7ec&scoped=true"
import script from "./AuthPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd38c7ec",
  null
  
)

export default component.exports